import { fetchClient } from '@/util/fetchClient';

export interface AddressSuggestion {
  placeId: string;
  description: string;
}

export interface ParsedAddress {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  formattedAddress: string;
}

/**
 * Fetch address suggestions from Google Places via our backend proxy.
 */
export async function fetchAddressSuggestions(
  input: string,
  sessionToken: string
): Promise<AddressSuggestion[]> {
  const { data } = await fetchClient.GET('/v2/places/autocomplete', {
    params: { query: { input, sessionToken } },
  });

  return data?.suggestions ?? [];
}

/**
 * Fetch structured address details for a selected place via our backend proxy.
 */
export async function fetchAddressDetails(
  placeId: string,
  sessionToken: string
): Promise<ParsedAddress> {
  const { data } = await fetchClient.GET('/v2/places/details', {
    params: { query: { placeId, sessionToken } },
  });

  if (!data?.address) {
    throw new Error('No address data returned');
  }

  return data.address;
}
